import { el } from "../util/dom";

/** A password <input> paired with an accessible show/hide toggle. Built with
 * the same el() helper (textContent only, zero innerHTML) so it stays inside
 * the strict-CSP contract. The toggle flips the input between "password" and
 * "text"; it starts hidden. type="button" keeps it from submitting anything,
 * and a <button> is keyboard-operable (Enter/Space) for free. aria-pressed +
 * aria-label announce the current state to assistive tech. Shared by the
 * login form (authView) and the registration screen (registerView). */
export function buildPasswordField(placeholder: string): {
  wrap: HTMLElement;
  input: HTMLInputElement;
} {
  const input = el("input", {
    type: "password",
    placeholder,
    class: "auth-input auth-input-password",
  }) as HTMLInputElement;
  const toggle = el(
    "button",
    {
      type: "button",
      class: "auth-password-toggle",
      "aria-label": "Show password",
      "aria-pressed": "false",
    },
    ["Show"]
  ) as HTMLButtonElement;
  toggle.addEventListener("click", () => {
    const reveal = input.type === "password";
    input.type = reveal ? "text" : "password";
    toggle.textContent = reveal ? "Hide" : "Show";
    toggle.setAttribute("aria-pressed", reveal ? "true" : "false");
    toggle.setAttribute("aria-label", reveal ? "Hide password" : "Show password");
  });
  const wrap = el("div", { class: "auth-password-wrap" }, [input, toggle]);
  return { wrap, input };
}
